<template>
  <div>
    <header1></header1>
    <div class="new_content" style="background: #FFFFFF;width:1002px;padding-bottom: 20px">
      <div class="new_findPwd_title" style="height: 76px;padding-left: 15px;">
        <!--<router-link to="/findByMobile">证件号找回密码</router-link>-->
        <!--<router-link to="/findByEmail" >邮箱找回密码</router-link>-->
        <router-link class="new_findPwd_title_sel" to="/findByShortMsg"
        >短信找回密码
        </router-link
        >
      </div>
      <div class="new_findPwd_main">
        <div v-show="active == 1">
          <el-form
            ref="mobileForm"
            :model="mobileForm"
            :rules="mobileRules"
            class="formcss"
            label-width="100px"
          >
            <el-form-item label="手机号" prop="mobile">
              <el-input
                v-model="mobileForm.mobile"
                autocomplete="off"
                placeholder="请输入11位手机号码"
                style="width:370px"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="mobileCode">
              <!-- 滑块验证 -->
              <div v-show="verifyShow" class="verifyMain">
                <Verify
                  ref="verify"
                  :captchaType="'blockPuzzle'"
                  :imgSize="{
                    width: '240px',
                    height: '120px',
                  }"
                  :mode="'fixed'"
                  @success="success"
                ></Verify>
                <div v-show="verifyOK" class="verifyOK">
                  <i
                    class="el-icon-success"
                    style="color:#67C23A;margin-left:12px;margin-right:8px"
                  ></i>
                  验证通过
                </div>
              </div>
              <el-input
                v-model="mobileForm.mobileCode"
                autocomplete="off"
                placeholder="请输入短信验证码"
                style="width: 280px"
              ></el-input>
              <el-button
                :disabled="sendSmsButtonDisabled"
                size="small"
                style="margin-left: 10px;padding:10px 9px;"
                type="primary"
                @click.native="sendSmsMethod"
              >
                {{ sendSmsButtonText }}
              </el-button>
              <!-- <a href="javascript:;" class="yz ml-20 pa"
                               title="①手机接收短信偶尔会有延时状况，请耐心等待;②尝试到手机短信拦截记录里找找看;③若有疑问请拨打客服电话：400-822-2055">没有收到验证码？</a> -->
            </el-form-item>
            <el-form-item>
              <el-button
                :disabled="nextButtonDisabled"
                style="width:276px;"
                type="primary"
                @click.native="nextMobile"
              >下一步
              </el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active == 2">
          <el-form
            ref="pwdForm"
            :model="pwdForm"
            :rules="pwdRules"
            class="formcss"
            label-width="100px"
          >
            <el-form-item :show-message="false" class="no_margin_bottom" label="新密码" prop="newPwd">
              <el-input
                v-model="pwdForm.newPwd"
                :maxLength="16" :type="pwdForm.showNewPwd ? 'text' : 'password'"
                autocomplete="new-password"
                placeholder="请输入8-16位包含大小写字母，特殊字符和数字的密码"
                style="width: 440px"
              >
                <i slot="suffix" :class="['el-input__icon', pwdForm.showNewPwd ? 'ri-eye-fill' : 'ri-eye-off-fill']"
                  @click="pwdForm.showNewPwd = !pwdForm.showNewPwd"></i>
              </el-input>
              <div class="form_password_verifiers">
                <el-tag :type="PasswordLengthRge().test(pwdForm.newPwd) ? 'success' : 'info'" hit>
                  <i class="el-icon-success"></i>8-16位之间
                </el-tag>
                <el-tag :type="UppercaseLowercaseReg().test(pwdForm.newPwd) ? 'success' : 'info'" hit>
                  <i class="el-icon-success"></i>含大小写字母
                </el-tag>
                <el-tag :type="NumberReg().test(pwdForm.newPwd) ? 'success' : 'info'" hit>
                  <i class="el-icon-success"></i>含数字
                </el-tag>
                <el-tag :type="SpecialCharactersReg().test(pwdForm.newPwd) ? 'success' : 'info'" hit>
                  <i
                    class="el-icon-success"></i>含特殊字符，如:@#*
                </el-tag>
              </div>
            </el-form-item>
            <el-form-item label="确认密码" prop="reNewPwd">
              <el-input
                v-model="pwdForm.reNewPwd"
                :type="pwdForm.showReNewPwd ? 'text' : 'password'"
                autocomplete="new-password"
                placeholder="请再一次输入密码"
                style="width: 440px"
              >
                <i slot="suffix"
                  :class="['el-input__icon', pwdForm.showReNewPwd ? 'ri-eye-fill' : 'ri-eye-off-fill']"
                  @click="pwdForm.showReNewPwd = !pwdForm.showReNewPwd"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="width:276px;" type="primary" @click="updatePwd"
              >确定
              </el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active == 3">
          <div class="new_content" style="width: 100%">
            <div style="padding:5% 0;">
              <p class="new_zc_sucess">重置密码成功!</p>
              <p class="new_zc_welcome">
                <!-- 账号：<span>{{ userName }}</span -->
                <!--<router-link to="/">立即登录</router-link>-->
                <a @click="toLogin">立即登录</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
import header1 from '../components/Header1'
import footer1 from '../components/Footer1'
import md5 from 'crypto-js/md5'
import Verify from '../components/verifition/Verify'
import { aesEncryptWord } from '../components/verifition/utils/ase.js'

import { updatePwdNew } from '../api/api'
import { getsms, smsvalidate } from '../api/apiLoginVerify.js'
import { passwordvali } from '../utils/validate.js'
import {
  NumberReg,
  PasswordLengthRge,
  PasswordReg,
  phoneReg,
  SpecialCharactersReg,
  UppercaseLowercaseReg
} from '../utils/commonReg'
import smCrypto from 'sm-crypto'
import { validateAgainPassword } from '../components/ChangePassword'

export default {
  components: {
    header1,
    footer1,
    Verify
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
        
      }
    }
    var validateVPhoneCode = (rule, value, callback) => {
      if (!this.mobileForm.mobile) {
        callback(new Error('请先获取手机验证码'))
      } else if (!value) {
        callback(new Error('请输入手机验证码'))
      } else {
        callback()
        
        // validateMobileCode({ key: this.mobileCodeKey, code: value }).then(
        //   ({ data }) => {
        //     if (data.success == true) {
        //       callback()
        //     } else {
        //       callback(new Error(data.msg))
        //     }
        //   }
        // )
      }
    }
    var validateVpassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.pwdForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      phoneReg: phoneReg,
      passwordvali: passwordvali,
      verifyOK: false,
      verifyShow: false,
      captchaVerification: '',
      yzmeffect: false, //是否获取验证码并有效
      mobileForm: {
        mobile: '',
        mobileCode: ''
      },
      pwdForm: {
        newPwd: '',
        showNewPwd: false,
        reNewPwd: '',
        showReNewPwd: false
      },
      active: 1,
      userName: '',
      smsTime: 0,
      mobileCodeKey: '',
      mobileRules: {
        mobile: [{required: true, validator: validateMobile, trigger: 'blur'}],
        mobileCode: [{required: true, validator: validateVPhoneCode, trigger: 'blur'}]
      },
      pwdRules: {
        newPwd: [
          {required: true, pattern: PasswordReg, trigger: 'blur'}
        ],
        reNewPwd: [{
          required: true, validator: (rule, value, callback) => {
            validateAgainPassword(rule, value, callback, this.pwdForm.newPwd)
          }, trigger: 'change'
        }]
      }
    }
  },
  computed: {
    sendSmsButtonDisabled() {
      if (this.mobileForm.mobile.length < 1 || this.yzmeffect) {
        return true
      } else {
        return false
      }
    },
    nextButtonDisabled() {
      if (this.mobileForm.mobile.length < 1 || this.mobileForm.mobileCode.length < 1) {
        return true
      } else {
        return false
      }
    },
    sendSmsButtonText() {
      return this.smsTime > 0 ? this.smsTime + 's' : '获取验证码'
    }
  },
  methods: {
    toLogin() {
      window.location.href = window.location.origin
      // this.$router.replace({
      //   path: '/'
      // })
    },
    SpecialCharactersReg() {
      return SpecialCharactersReg
    },
    NumberReg() {
      return NumberReg
    },
    UppercaseLowercaseReg() {
      return UppercaseLowercaseReg
    },
    PasswordLengthRge() {
      return PasswordLengthRge
    },
    success(params) {
      // this.verifyOK = true
      this.captchaVerification = params
      // setTimeout(() => {
      //   this.verifyShow = false
      //   this.verifyOK = false
      // }, 1000)
      this.verifyShow = false
      //  this.smsTime = 60
      this.sendyzm()
    },
    smsTimer() {
      if (this.smsTime > 0) {
        this.yzmeffect = true // 验证码在60s有效期
        this.smsTime--
        setTimeout(this.smsTimer, 1000)
      } else {
        this.yzmeffect = false
      }
    },
    /**
     * @description: 发送验证码
     * @author: lly
     */
    sendyzm() {
      let param = {
        mobile: aesEncryptWord(this.mobileForm.mobile),
        captchaVerification: this.captchaVerification.captchaVerification,
        flag: 1
      }
      getsms(param).then((res) => {
        this.$message.success('已发送手机验证码')
        this.yzmeffect = true // 验证码在60s有效期
        this.smsTime = 60
        this.smsTimer()
        this.mobileCodeKey = res.data.key
      })
    },
    sendSmsMethod() {
      this.$refs.mobileForm.validateField('mobile', (error) => {
        if (!error) {
          this.verifyShow = true
          // isValidMoblile({ mobile: this.mobileForm.mobile }).then(({ data }) => {
          //  if (data.code != 0) {
          //    this.$message.warning(data.msg)
          //  }else{
          //   this.verifyShow=true
          //  }
          // })
          
        }
      })
    },
    
    nextMobile() {
      this.$refs.mobileForm.validate((valid) => {
        if (valid) {
          let paramyzm = {
            mobile: this.mobileForm.mobile,
            code: this.mobileForm.mobileCode
          }
          smsvalidate(paramyzm).then(res => {
            if (this.active++ > 2) this.active = 0
          })
          
        } else {
          return false
        }
      })
    },
    
    updatePwd() {
      // if (this.active++ > 2) this.active = 0
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          let param = {
            password: md5(this.pwdForm.newPwd).toString(),
            password2: smCrypto.sm3(this.pwdForm.newPwd),
            mobile: this.mobileForm.mobile,
            mobileCode: this.mobileForm.mobileCode
          }
          updatePwdNew(param).then(({data}) => {
            if (data.code == 0) {
              if (this.active++ > 2) this.active = 0
            } else {
              this.$message.error(data.msg)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.verifyMain {
  position: absolute;
  top: -97px;
  left: 0px;
}

.verifyMain {
  position: absolute;
  z-index: 999;
  top: 0;
  right: 0;
  width: 260px;
  height: 200px;
  padding: 10px;
  background: #FFFFFF;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.formcss {
  width: 530px;
  margin: 0 auto;
}

.new_findPwd_title {
  font-size: 14px;
  height: 37px;
  padding-top: 40px;
}

.new_findPwd_title a {
  line-height: 36px;
  display: block;
  float: left;
  width: 130px;
  height: 36px;
  margin-right: 12px;
  text-align: center;
  color: #5F5F5F;
  border: #C9C9C9 1px solid;
  border-bottom: 0px;
}

.new_findPwd_title a.new_findPwd_title_sel {
  color: #FFFFFF;
  border: #4A95A5 1px solid;
  border-bottom: 0px;
  background: #4A95A5;
}

.new_fpwx_title {
  font-weight: bold;
  line-height: 40px;
  text-align: left;
  color: #38BCD5;
}

.new_fpwx_img {
  text-align: center;
}

.new_findPwd_main {
  width: 100%;
  min-height: 340px;
  padding: 40px 0px 0px 0px;
  border: 1px #C9C9C9 solid;
}

p.new_zc_sucess {
  font-size: 30px;
  line-height: 40px;
  width: 245px;
  height: 40px;
  margin: 0px auto;
  padding-left: 36px;
  text-align: left;
  color: #66A000;
  background: url(../assets/img-4/sucess_bg.gif) no-repeat left center;
}

p.new_zc_welcome {
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}

p.new_zc_welcome span,
p.new_zc_welcome a {
  color: #FF5300;
}

p.new_zc_welcome a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/FindByShortMsg.vue